import React, { useState, useEffect } from 'react';
import './Time.css';

const Time = () => {
  const [hours, setHours] = useState(new Date().getHours());
  const [minutes, setMinutes] = useState(new Date().getMinutes());
  const [seconds, setSeconds] = useState(new Date().getSeconds());
  const [quizTime, setQuizTime] = useState({ hours: 0, minutes: 0 });
  const [isQuizMode, setIsQuizMode] = useState(false);
  const [quizAnswer, setQuizAnswer] = useState('');

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      setHours(now.getHours());
      setMinutes(now.getMinutes());
      setSeconds(now.getSeconds());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const speakTime = () => {
    const utterance = new SpeechSynthesisUtterance(`The time is ${hours} ${minutes}`);
    window.speechSynthesis.speak(utterance);
  };

  const handleQuizStart = () => {
    const randomHours = Math.floor(Math.random() * 24);
    const randomMinutes = Math.floor(Math.random() * 60);
    setQuizTime({ hours: randomHours, minutes: randomMinutes });
    setIsQuizMode(true);
    setQuizAnswer('');
  };

  const handleQuizSubmit = () => {
    const correctAnswer = `${quizTime.hours.toString().padStart(2, '0')}:${quizTime.minutes.toString().padStart(2, '0')}`;
    setQuizAnswer(quizAnswer === correctAnswer ? 'Correct!' : `Wrong! The correct time was ${correctAnswer}`);
  };

  return (
    <div className="AppTime">
      <h1>Learn Time</h1>
      <div className="clock">
        <div className="hours">{hours.toString().padStart(2, '0')}</div>
        <div className="minutes">{minutes.toString().padStart(2, '0')}</div>
        <div className="seconds">{seconds.toString().padStart(2, '0')}</div>
      </div>
      <button onClick={speakTime}>Speak Time</button>
      <div className="interactive">
        <h2>Interactive Time Setting</h2>
        <input type="number" value={hours} onChange={(e) => setHours(e.target.value)} max={23} min={0} />
        <input type="number" value={minutes} onChange={(e) => setMinutes(e.target.value)} max={59} min={0} />
        <button onClick={speakTime}>Set Time and Speak</button>
      </div>
      {/* <div className="quiz-mode">
        <h2>Quiz Mode</h2>
        {isQuizMode ? (
          <div>
            <p>What time is it?</p>
            <input
              type="text"
              placeholder="HH:MM"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
            />
            <button onClick={handleQuizSubmit}>Submit</button>
            {quizAnswer && <p>{quizAnswer}</p>}
          </div>
        ) : (
          <button onClick={handleQuizStart}>Start Quiz</button>
        )}
      </div> */}
    </div>
  );
};

export default Time;
